import { Link } from 'react-router-dom';
import type { FaqItem } from './faqTypes';

export const faqItemsDe: FaqItem[] = [
  {
    q: 'Was bedeutet „Missed Connection“ eigentlich?',
    a: (
      <>
        <p>
          Eine Missed Connection ist eine verpasste Begegnung zwischen zwei Menschen, bei der ein Moment
          spürbar war – aber kein Kontakt zustande kam.
        </p>
        <p>
          Vielleicht ein Blick.
          <br />
          Ein Lächeln.
          <br />
          Ein Gefühl von „Da war etwas“.
        </p>
        <p>
          <strong>I Think It’s You :|:</strong> gibt genau diesen Momenten eine zweite Chance.
        </p>
      </>
    ),
  },
  {
    q: 'Wie funktioniert I Think It’s You konkret?',
    a: (
      <>
        <p>Ganz einfach:</p>
        <ol className="faq-answer-list faq-answer-list--numbered">
          <li>Du erinnerst dich an eine Begegnung</li>
          <li>Du beschreibst sie möglichst genau</li>
          <li>Du veröffentlichst deinen Eintrag</li>
        </ol>
        <p>
          Andere können diesen lesen – und wenn sie sich wiedererkennen, entsteht Kontakt.
        </p>
        <p>
          👉{' '}
          <a href="https://www.i-think-its-you.at" target="_blank" rel="noopener noreferrer">
            www.i-think-its-you.at
          </a>
        </p>
      </>
    ),
  },
  {
    q: 'Was sollte ich in meinen Eintrag schreiben?',
    a: (
      <>
        <p>Je genauer, desto besser:</p>
        <ul className="faq-answer-list">
          <li>Ort (z. B. Café, Event, Straße)</li>
          <li>Zeitpunkt</li>
          <li>Beschreibung der Person</li>
          <li>Was passiert ist</li>
          <li>Warum dich der Moment berührt hat</li>
        </ul>
        <p>
          <strong>👉 Wichtig: Respektvoll, ehrlich und ohne private Daten.</strong>
        </p>
      </>
    ),
  },
  {
    q: 'Ist das anonym?',
    a: (
      <>
        <p>Ja.</p>
        <p>Du entscheidest selbst, wie viel du preisgibst.</p>
        <p>Diskretion ist Teil des Konzepts.</p>
      </>
    ),
  },
  {
    q: 'Ist „I Think It’s You“ eine Dating-Plattform?',
    a: (
      <>
        <p>Nein – und genau das ist der Unterschied.</p>
        <p>Es geht nicht um Profile, Matching oder Algorithmen.</p>
        <p>Es geht um echte Begegnungen im echten Leben.</p>
        <p>
          👉 <strong>I Think It’s You</strong> beginnt dort, wo andere Plattformen aufhören.
        </p>
      </>
    ),
  },
  {
    q: 'Funktioniert das wirklich?',
    a: (
      <>
        <p>Ja.</p>
        <p>
          <strong>Missed-Connection-Plattformen</strong> existieren weltweit seit vielen Jahren – und immer
          wieder finden sich Menschen auf genau diesem Weg wieder.
        </p>
        <p>Nicht jede Spur führt zum Ziel.</p>
        <p>Aber manche schon.</p>
      </>
    ),
  },
  {
    q: 'Warum gibt es so eine Plattform überhaupt?',
    a: (
      <>
        <p>Weil viele Begegnungen zu schnell vorbeigehen.</p>
        <ul className="faq-answer-list">
          <li>weil man sich nicht traut</li>
          <li>weil der Moment nicht passt</li>
          <li>weil man es erst später realisiert</li>
        </ul>
        <p>
          <strong>I Think It’s You :|:</strong> macht aus diesen Momenten Möglichkeiten.
        </p>
      </>
    ),
  },
  {
    q: 'Ist das nur für Singles gedacht?',
    a: (
      <>
        <p>Nein.</p>
        <p>Es geht nicht nur um romantische Begegnungen, sondern um:</p>
        <ul className="faq-answer-list">
          <li>Sympathie</li>
          <li>Neugier</li>
          <li>menschliche Verbindung</li>
        </ul>
      </>
    ),
  },
  {
    q: 'Kann ich auch jemanden finden, den ich nur kurz gesehen habe?',
    a: (
      <>
        <p>Ja – genau dafür ist die Plattform da.</p>
        <p>Selbst flüchtige Begegnungen können ausreichen, wenn die Beschreibung präzise ist.</p>
      </>
    ),
  },
  {
    q: 'Was passiert, wenn sich niemand meldet?',
    a: (
      <>
        <p>Dann bleibt dein Eintrag eine Spur.</p>
        <p>Nicht jede Spur wird gelöst.</p>
        <p>Aber jede erzählt eine Geschichte.</p>
        <p>Und manchmal liest genau die richtige Person genau zur richtigen Zeit mit.</p>
      </>
    ),
  },
  {
    q: 'Gibt es Regeln für die Nutzung?',
    a: (
      <>
        <p>Ja – und sie sind wichtig:</p>
        <ul className="faq-answer-list">
          <li>respektvoller Umgang</li>
          <li>keine beleidigenden Inhalte</li>
          <li>keine sensiblen oder identifizierenden Daten</li>
          <li>keine Belästigung</li>
        </ul>
        <p>
          <strong>👉 I Think It’s You ist ein Raum für positive Begegnung.</strong>
        </p>
      </>
    ),
  },
  {
    q: 'Woher kommt die Idee der Missed Connections?',
    a: (
      <>
        <p>
          <strong>Missed Connections</strong> haben ihren Ursprung in klassischen Kontaktanzeigen und
          später in Online-Plattformen.
        </p>
        <p>
          Schon früh haben Menschen versucht, verpasste Begegnungen nachträglich wiederzufinden – über
          Zeitungen, schwarze Bretter oder digitale Inserate.
        </p>
        <p>
          <strong>I Think It’s You :|:</strong> führt diese Idee weiter – zeitgemäß, emotional und
          vernetzt mit echten Erlebnissen.
        </p>
      </>
    ),
  },
  {
    q: 'Was macht „I Think It’s You“ besonders?',
    a: (
      <ul className="faq-answer-list">
        <li>Verbindung zur realen Welt (Events, Alltag, Begegnungen)</li>
        <li>Teil des Crime Club Universums</li>
        <li>das Symbol :|: als stiller Code</li>
        <li>Fokus auf echte Momente statt Profile</li>
      </ul>
    ),
  },
  {
    q: 'Wie kann ich meine Chancen erhöhen?',
    a: (
      <>
        <ul className="faq-answer-list">
          <li>sei konkret (Ort, Zeit, Situation)</li>
          <li>beschreibe den Moment, nicht nur die Person</li>
          <li>schreibe authentisch</li>
        </ul>
        <p>
          <strong>👉 Menschen erinnern sich an Gefühle, nicht an Daten.</strong>
        </p>
      </>
    ),
  },
  {
    q: 'Kann ich mehrere Einträge machen?',
    a: (
      <>
        <p>Ja – jede Begegnung ist ein eigener Fall.</p>
        <p>Und jeder Fall verdient Aufmerksamkeit.</p>
      </>
    ),
  },
  {
    q: 'Ist das sicher?',
    a: (
      <>
        <p>Ja – bei verantwortungsvoller Nutzung.</p>
        <p>Die Plattform ist darauf ausgelegt, Begegnungen respektvoll und anonym zu ermöglichen.</p>
      </>
    ),
  },
  {
    q: 'Was ist das Signal?',
    a: (
      <>
        <p>
          Zeige das Signal auf deinem Handy jemandem, für den du eine Sichtung gepostet hast. Vielleicht
          sieht die Person es und kommt auf die Idee, auf <strong>I Think It’s You</strong> zu gehen.
        </p>
        <p>Vielleicht.</p>
      </>
    ),
  },
  {
    q: 'Was ist, wenn ich jemanden im Flugzeug oder im Zug gesehen habe?',
    a: (
      <p>
        Grundsätzlich solltest du eine Sichtung sowohl für den Abflugort als auch für den Ankunftort
        posten. Du musst zwei Sichtungen posten, da eine Sichtung immer nur an einem Ort gleichzeitig
        stattfinden kann.
      </p>
    ),
  },
  {
    q: 'Warum braucht „I Think It’s You“ meinen Standort?',
    a: (
      <>
        <p>
          <strong>I Think It’s You</strong> ist ein standortbasierter Messaging-Dienst.
        </p>
        <p>
          Deshalb brauchen wir den Ort, an dem du jemanden gesehen hast, damit diese Person ihn finden
          kann.
        </p>
        <p>
          Wenn du also jemanden in Paris gesehen hast, gibst du deinen Sichtungsort in Paris an. Ebenso
          kannst du ganz einfach nur die Sichtungen in deiner Stadt durchsuchen, sodass du nicht alle
          durchforsten musst.
        </p>
      </>
    ),
  },
  {
    q: 'Warum funktioniert „Position bestimmen“ nicht?',
    a: (
      <>
        <p>Es gibt mehrere mögliche Ursachen:</p>
        <ul className="faq-answer-list">
          <li>Dein Gerät unterstützt möglicherweise kein GPS.</li>
          <li>
            Du erhältst eine Fehlermeldung, wenn Bluetooth nicht aktiviert ist und/oder du nicht mit dem
            WLAN verbunden bist.
          </li>
          <li>Möglicherweise befindest du dich in einem Gebiet ohne Mobilfunkempfang.</li>
        </ul>
        <p>
          Wenn einer der oben genannten Punkte zutrifft, kannst du die Funktion „Stadt ändern“ nutzen, um
          zu navigieren.
        </p>
      </>
    ),
  },
  {
    q: 'Ich habe eine Sichtung versehentlich gelöscht. Kann ich sie wiederherstellen?',
    a: <p>Leider nein. Du musst sie neu eingeben.</p>,
  },
  {
    q: 'Wie lange bleiben meine Sichtungen gespeichert?',
    a: <p>Für immer oder bis der Nutzer sie löscht.</p>,
  },
  {
    q: 'Warum ist meine E-Mail zur Bestätigung oder zum Passwort Reset nicht angekommen?',
    a: (
      <>
        <p>Schau bitte unbedingt in Deinem Spam-Ordner nach.</p>
        <p>
          Füge außerdem{' '}
          <a href="mailto:noreply@i-think-its-you.at">noreply@i-think-its-you.at</a> zu Deinen Kontakten
          hinzu.
        </p>
        <p>
          Wenn das alles nichts hilft, nutze unser <Link to="/contact">Kontaktformular</Link>, um um Hilfe
          zu bitten, und wir kümmern uns um deine Registrierung.
        </p>
      </>
    ),
  },
  {
    q: 'Soll ich meine Kontaktdaten in meinem Sichtungsbericht angeben?',
    a: (
      <>
        <p>Nein.</p>
        <p>Das setzt dich nur der Gefahr von Spam oder Betrug aus.</p>
        <p>
          Mitglieder nutzen die Schaltfläche „Chat“, um andere zu kontaktieren und auf einen
          Sichtungsbericht zu antworten.
        </p>
      </>
    ),
  },
];
